import { Box, SxProps, Theme } from '@mui/material';
import { FC } from 'react';
import { getColor } from '../../helpers/color';

interface ColorCircleProps {
  code: string;
  selected: boolean;
  onSelect: (code: string) => void;
  sx?: SxProps<Theme>;
}

export const ColorCircle: FC<ColorCircleProps> = ({ code, selected, onSelect, sx }) => (
  <Box
    onClick={() => onSelect(code)}
    sx={{
      width: 30,
      height: 30,
      borderRadius: '50%',
      backgroundColor: getColor(code),
      border: selected ? '2px solid var(--tgui--button_color)' : '2px solid transparent',
      ...sx,
    }}
  />
); 